<template>
    <div>
      <v-expansion-panels v-model="panelState">
        <v-expansion-panel class="rounded-lg border-grey">
          <!-- Styled Header / Label -->
          <v-expansion-panel-header class="py-3 px-4 bg-light">
            <template v-slot:default="{ open }">
              <div class="d-flex align-center w-100">
                <!-- Optional Icon -->
                <v-avatar size="36" color="primary lighten-5" class="mr-3" v-if="showIcon">
                  <v-icon color="primary" small>{{ icon }}</v-icon>
                </v-avatar>
  
                <!-- Header Labels -->
                <div>
                  <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
                    {{ mainLabel }}
                  </div>
                  <div class="text-caption grey--text text--darken-1">
                    {{ dynamicSubLabel }}
                  </div>
                </div>
  
                <v-spacer></v-spacer>
  
                <!-- Quick Status Badge -->
                <v-chip
                  x-small
                  label
                  :color="open ? 'success' : 'warning'"
                  :text-color="'white'"
                  class="mr-2 font-weight-bold"
                >
                  {{ open ? 'Active' : 'Tap to View' }}
                </v-chip>
              </div>
            </template>
          </v-expansion-panel-header>
  
          <!-- Dynamic Panel Content Slot -->
          <v-expansion-panel-content class="pt-2">
            <!-- 
              Scoped slot exposes the `handleSelection` method to whatever 
              child component is placed inside by the parent.
            -->
            <slot name="content" :select="handleSelection">
              <div class="py-4 text-center grey--text">
                No content provided.
              </div>
            </slot>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </template>
  
  <script>
  export default {
    name: "ExpansionPanelWrapper",
    props: {
      showIcon: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: "mdi-file-document-outline"
      },
      label: {
        type: String,
        default: "Label"
      },
      subLabel: {
        type: String,
        default: ""
      },
      selectedItem: {
        type: Object,
        default: null
      }
    },
    watch:{
      label:{
        immediate:true,
        handler(newVal){
          if (newVal) this.setMainLabel(newVal);
        }
      },

    },
    data() {
      return {
        // 0 = open, null = collapsed
        panelState: 0,
        mainLabel:""
      };
    },
    computed: {
      isMobile() {
        // Prefers Vuex getter if available, falls back to Vuetify breakpoint
        if (this.$store && this.$store.getters && 'isMobile' in this.$store.getters) {
          return this.$store.getters.isMobile;
        }
        return this.$vuetify.breakpoint.xsOnly;
      },
      dynamicSubLabel() {
        if (this.selectedItem && this.selectedItem.name) {
          return `Selected: ${this.selectedItem.name}`;
        }

        if (this.subLabel) {
          return this.subLabel;
        }

        return "Tap to View or Select Options";
      }
    },
    methods: {
      setMainLabel(label){
        this.mainLabel = label
      },
      handleSelection(payload) {
        // Emit selection payload to parent component
        this.$emit("item-clicked", payload);
  
        // Auto-collapse panel on mobile screen sizes
        if (this.isMobile) {
          this.panelState = null;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .border-grey {
    border: 1px solid #e0e0e0 !important;
  }
  
  .bg-light {
    background-color: #f8f9fa !important;
  }
  
  .custom-panel .v-expansion-panel-header {
    min-height: 64px;
  }
  </style>